import {gql} from '@apollo/client/core';
import {PriceTableFragment} from './price-table.fragment';
import {ProductAllMetaFragment} from './product-all-meta.fragment';


export const ProductDataFragment = gql`
  fragment productData on WineProduct {
    id
    productId
    inStock
    defaultQuantity
    preorderDate
    canBeAddedToCart
    nodePath
    ctaLink
    pageWhitelist
    ctaTitle
    ctaStockText
    longText
    showSavings
    isB2b
    vimeoId
    hideDiscountCountdown
    name
    body
    supplierName
    pdfText
    vismaProductNumber
    sku
    has360BottleImage
    packaging
    closure
    shortText
    hidePriceTable
    hideShippingCountdown
    hideSupervinAdvantages
    topCta {
      text
      icon
      type
    }
    isLeftover
    isEnPrimeur
    productImageBadge {
      type
      value
    }
    images {
      id
      large
      height
      width
      small
    }
    image {
      id
      original
      large
      small
      thumbnail
      height
      width
    }
    productAuthor {
      id
      name
      tagline
      image
    }
    tags {
      altText
      color
      icon
      text
    }
    priceTable {
      ...priceTable
    }
    meta {
      ...productAllMeta
    }
    suggestedRetailPrice
    __typename
  }
  ${PriceTableFragment}
  ${ProductAllMetaFragment}
`;
